(function () {
  'use strict';

  function initAnnouncement() {
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) return;
    var $el = jQuery('.announcement-1');
    if (!$el.length) return;
    if ($el.hasClass('slick-initialized')) {
      try {
        $el.slick('slickSetOption', 'autoplaySpeed', 5000, true);
      } catch (_) {}
      return;
    }
    $el.slick({
      lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      dots: false,
      arrows: false,
      adaptiveHeight: true
    });
  }

  function onCartLoaded(cart) {
    var container = document.getElementById('CartContainer');
    if (!container) return;

    var footer = container.querySelector('.ajaxcart__footer');
    var checkoutBtn = container.querySelector('.cart__checkout');
    if (footer && checkoutBtn && !footer.querySelector('[data-wearth-hormozi-reassurance]')) {
      var reassurance = document.createElement('p');
      reassurance.className = 'wearth-hormozi-cart-reassurance';
      reassurance.setAttribute('data-wearth-hormozi-reassurance', '');
      reassurance.textContent = '30 days to decide. Free pickup if it goes back.';
      checkoutBtn.insertAdjacentElement('afterend', reassurance);
    }

    if (checkoutBtn && checkoutBtn.textContent.indexOf('Checkout') === -1) {
      var price = checkoutBtn.textContent.replace(/^Checkout\s*~?\s*/i, '').trim();
      checkoutBtn.textContent = price ? 'Checkout ' + price : 'Checkout';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    if (typeof jQuery !== 'undefined') {
      jQuery(document.body).on('afterCartLoad.ajaxCart', function (_evt, cart) {
        onCartLoaded(cart);
      });
    }
  });

  if (document.readyState !== 'loading') {
    initAnnouncement();
  }
})();
